module.exports = __webpack_public_path__ + "static/media/03_plantilla_combo_rectangular_logo_cc_rojo.03c09ae2.png";